import { useInvoiceWireTransferActivationStatusQuery } from 'modules/company/general-settings';
import { type QueryState } from 'src/core/api/queryState';

export const useCanActivateInvoiceWireTransferQuery =
  (): QueryState<boolean> => {
    const wireTransferActivationStatusQueryState =
      useInvoiceWireTransferActivationStatusQuery();

    if (wireTransferActivationStatusQueryState.status === 'success') {
      return {
        ...wireTransferActivationStatusQueryState,
        data:
          wireTransferActivationStatusQueryState.data.toggle.canToggle &&
          wireTransferActivationStatusQueryState.data.isActivated === false,
      };
    }

    return wireTransferActivationStatusQueryState;
  };
